<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CompanyAPI from "@/services/company/companyAPI";
import ActivityAPI from "@/services/standards/trainingProgram/activityHealthAPI";
import ItemAPI from "@/services/items/itemsAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "../../../../services/newScores/newScoresAPI"

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.2 Actividades de Promoción y Prevención en Salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.1.2 Actividades de Promoción y Prevención en Salud",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "3.1.2 Actividades de Promoción y Prevención en Salud",
          href: `/forms/estandares/${this.$route.params.promotion}/actividades-promocion`,
        },
        {
          text: "Evidencia",
          active: true,
        },
      ],

      file: null,
      loading: true,
      submitted: false,
      list: [],

      evi: null,

      usersList: [],
      itemData: null,
      program: {
        activity: null,
        scheduled_date: null,
        observations: null,
        programs_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      evidencia: {
        evidence: null,
        activity_promotions_id: this.$route.params.promotion,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      promotionID: this.$route.params.promotion,
      company: this.$store.getters["company/getCompany"] || null,
      nit: this.$store.getters["company/getCompany"].nit || null,

      programa: [
        {
          name: "Biomecánico",
          id: 1,
        },
        {
          name: "Auditivo",
          id: 2,
        },
        {
          name: "Respiratorio",
          id: 3,
        },
        {
          name: "Biológico",
          id: 4,
        },
        {
          name: "Psicosocial",
          id: 5,
        },
        {
          name: "Otro",
          id: 6,
        },
      ],
    };
  },
  validations: {
    program: {
      programs_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(24)
        .then((response) => {
          this.itemData = response;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.evidencia.evidence)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.2/${this.$route.params.promotion}/evidencia/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.2/${this.$route.params.promotion}/evidencia/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.evidencia.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async save() {
      try {
        this.submitted = true
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          const data = {
            evidence: this.evidencia.evidence,
            activity_promotions_id: this.promotionID,
            companies_id: this.$store.getters["company/getCompany"].id || null,
          };
          ActivityAPI.saveEvidence(data)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 24,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      icon: "success",
                      type: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.$router.go(-1);
                  }, 1000);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              icon: "warning",
              type: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              let informacion = res.employee;
              this.usersList = informacion;
              this.loading = false
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },


    getData() {
      ActivityAPI.get(this.$route.params.promotion)
        .then((response) => {
          this.evi = response.program_evidencen;
          this.program.activity = response.activity;
          this.program.scheduled_date = response.scheduled_date;
          this.program.employee_id = response.employee_id;
          this.program.programs_id = response.programs_id;
          this.program.observations = response.observations;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      ActivityAPI.getEvidence(this.promotionID)
        .then((response) => {
          const evidencia = response;
          this.evidencia.evidence = response.evidence;
          this.evidencia.activity_promotions_id = response.evidence;
          this.evidencia.companies_id = response.companies_id;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getShow();
    this.getUsers();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />
            <form v-if="this.evi.length > 0" class="form-group" @submit.prevent="save">
              <div class="form-row col-12">
                <b-form-group class="col-md-4 px-2" label="Programa" label-for="theme">
                  <b-form-select disabled id="theme" v-model="program.programs_id" v-on:change="getDataTraining()">
                    <b-form-select-option v-for="(item, index) in programa" :key="index" :value="item.id">
                      {{ item.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group class="col-md-4 px-2" label="Fecha Programada" label-for="trainingDate">
                  <b-form-input type="date" id="trainingDate" disabled v-model="program.scheduled_date">
                  </b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4" label="Responsable" label-for="employee">
                  <select id="employeeID" disabled class="form-control" v-model="program.employee_id">
                    <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                      {{ item.full_name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
              </div>
              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2" label="Actividad" label-for="description">
                  <b-form-textarea disabled id="description" v-model="program.activity">
                  </b-form-textarea>
                </b-form-group>
              </div>

              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                  <b-form-textarea disabled id="description" v-model="program.observations">
                  </b-form-textarea>
                </b-form-group>
              </div>
              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2 text-center" label="Descargar archivo" label-for="file">
                  <div class="d-flex justify-content-center">
                    <button :disabled="!allowAccess()" style="
                      background-color: transparent !important;
                      border: none;
                    " type="button" @click="gotoDigitalOcean(`${evi[0].evidence}`)">
                      <i class="mdi mdi-cloud-download"></i>
                    </button>
                  </div>
                </b-form-group>
              </div>

            </form>
            <form v-else class="form-group" @submit.prevent="save">
              <div class="form-row col-12">
                <b-form-group class="col-md-4 px-2" label="Programa" label-for="theme">
                  <b-form-select disabled id="theme" v-model="program.programs_id" v-on:change="getDataTraining()">
                    <b-form-select-option v-for="(item, index) in programa" :key="index" :value="item.id">
                      {{ item.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group class="col-md-4 px-2" label="Fecha Programada" label-for="trainingDate">
                  <b-form-input type="date" id="trainingDate" disabled v-model="program.scheduled_date">
                  </b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4" label="Responsable" label-for="employee">
                  <select id="employeeID" disabled class="form-control" v-model="program.employee_id">
                    <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                      {{ item.full_name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
              </div>
              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2" label="Actividad" label-for="description">
                  <b-form-textarea disabled id="description" v-model="program.activity">
                  </b-form-textarea>
                </b-form-group>
              </div>

              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                  <b-form-textarea disabled id="description" v-model="program.observations">
                  </b-form-textarea>
                </b-form-group>
              </div>

              <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file" ref="file"
                  name="file" browse-text="Buscar" :placeholder="file
                    ? getFile(file) : `Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                  @change="uploadFile" v-on:change="uploadFile"
                  accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                </b-form-file>
              </b-form-group>

              <div class="form-group text-right m-b-0">
                <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                  Guardar
                </button>
                <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>

              <!-- end col -->
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <div v-else class="col-xl-12 text-center">
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
